import ContentService from '@master/Services/ContentService';
import UserService from '@master/Services/UserService';
import ActiveState from '@libs/ActiveState';

class GroupAssetsLibraryService extends ContentService {
  active = new ActiveState();

  load() {
    const path = this.#getPath();

    if (path != null) {
      super.load(path);
    }
  }

  loadMore() {
    const path = this.#getPath();

    if (path != null) {
      super.loadMore(path);
    }
  }

  updateSorting(sort, reverse) {
    const path = this.#getPath();

    if (path != null) {
      super.updateSorting(sort, path, reverse);
    }
  }

  #getPath() {
    const group = UserService.getGroup();
    const library_id = group.library?.library_id;

    if (!library_id) {
      return null;
    }

    let path = `assets/library/${library_id}`;

    const folder_id = this.router.history.current?.params?.folder_id;
    if (folder_id != null) {
      path += `/folder/${folder_id}`;
    }

    return path;
  }

  columns = [null, null, { name: 'Name', key: 'name' }, { name: 'Size', key: 'size' }, { name: 'Uploaded By', key: 'owner' }, { name: 'Date Added', key: 'created_on' }];
}

export default new GroupAssetsLibraryService();
